import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    background-color: #0F1A2A;
    text-align: center;
    padding: 70px 60px;

    @media (max-width: 1000px) {
        padding: 40px 20px;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    max-width: 1100px;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 26px;
    font-weight: 600;
    margin: 0 0 20px 0;

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;
        margin: 0 0 40px 0;
    }
`

export const BoxConteudo = styled.div`
    float: left;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`

export const BoxConteudoTextos = styled.div`
    float: left;
    width: 50%;
    padding-left: ${props => props.padding ? '80px' : '0' };

    @media (max-width: 1000px) {
        width: 100%;
        padding: 0;
        padding-left: 0;
        padding-top: ${props => props.padding ? '40px' : '0' };
    }
`

export const BoxConteudoTextosTitulo = styled.span`
    float: left;
    width: 100%;
    color: #F09C00;
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px 0;

    @media (max-width: 1000px) {
        font-size: 20px;
    }
`

export const BoxConteudoTextosSubtitulo = styled.span`
    float: left;
    width: 100%;
    color: #FFFFFF;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    margin: 0 0 20px 0;
`

export const BoxConteudoTextosTexto = styled.span`
    float: left;
    width: 100%;
    color: #CBD4E1;
    font-size: 13px;
    line-height: 26px;
    margin-bottom: ${props => props.margin ? '20px' : '0' };
`

export const BoxConteudoFigure = styled.figure`
    float: left;
    width: 50%;
    text-align: center;
    position: relative;
    margin: 0;

    :after {
        content: "";
        width: 1px;
        height: 1px;
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 50%;
        -webkit-box-shadow: inset -1px 3px 8px 5px #1F87FF, 2px 5px 16px 0px #0B325E, 9px 13px 150px 150px rgba(255, 255, 255, 0.2);
        box-shadow: inset -1px 3px 8px 5px #1F87FF, 2px 5px 16px 0px #0B325E, 9px 13px 150px 150px rgba(255, 255, 255, 0.2);
    }

    @media (max-width: 1000px) {
        width: 100%;
    }
`

export const BoxConteudoFigureImg = styled.img`
    display: inline-block;
    max-width: 100%;
`